export default __webpack_public_path__ + "assets/favicons/favicon-32x32.png";